import { render } from "./app-modal.vue?vue&type=template&id=b2ba97f4&ts=true"
import script from "./app-modal.vue?vue&type=script&lang=ts"
export * from "./app-modal.vue?vue&type=script&lang=ts"

import "./app-modal.vue?vue&type=style&index=0&id=b2ba97f4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__